import { Power3, gsap } from 'gsap';
import { ResizeHelper } from '../../dev/utils/ResizeHelper';
import { Helper } from "../../dev/utils/Helper";
import { TextStyleOptions, BitmapTextStyleOptions } from '../../dev/setting/text/IText';
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { AnimationEffects } from '../../dev/effects/AnimationEffects';
import { GameAssets } from '../config/texture/GameAssets';
import { RoadRage } from '../RoadRage';
import { BLEND_MODES } from 'pixi.js';

export class CarFSBox extends PIXI.Container {

    private DEFAULT_TEXT_STYLE: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily: "Helvetica",
        fontWeight: FontWeight.BOLD,
        fontSize: 28,
        align: "left",
        fill: [
            "white",
        ]
    };

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_COLLECTOR,
        fontSize: 14,
        letterSpacing:10,
        align:"center"
    };

    private _textMult: PIXI.BitmapText;
    private _textSplit: PIXI.BitmapText;
    protected _carBox: PIXI.Sprite;

    private prefPos:PIXI.Point = new PIXI.Point();

    protected _type: string;

    protected _timeline: gsap.core.Timeline;
    private enabled: boolean;
    private soonEnabled: boolean;

    private isSummary:boolean;

    private _gfxBox:PIXI.Sprite;


    // "Collector_FX"

    // "Collect_Blink_Landscape"
    // "Collect_Blink_Portrait"


    get isEnabled():boolean{
        return this.enabled;
    }

    get willBeEnabled():boolean{
        return this.soonEnabled;
    }

    get gfxTexture():PIXI.Texture{
        return RoadRage.assetLoader.getTextures("Collector_FX/" + (ResizeHelper.isLandscape || this.isSummary ? "Collect_Blink_Landscape" : "Collect_Blink_Portrait") )[0];
    }

    get boxTexture():PIXI.Texture{
        return RoadRage.assetLoader.getTextures(this._type + (ResizeHelper.isLandscape || this.isSummary ? "" : "2") )[0];
    }

    constructor(type:string, summary:boolean = false) {
        super();
        this.isSummary = summary;
        this._type = "Multiplier_Collect/Collect_" + type;

        this._carBox = this.addChild(new PIXI.Sprite(this.boxTexture));
        this._carBox.anchor.set(0.5,0.5);

        this._gfxBox = this.addChild(new PIXI.Sprite(this.gfxTexture));
        this._gfxBox.anchor.set(0.5,0.5);
        this._gfxBox.blendMode = BLEND_MODES.ADD;
        this._gfxBox.alpha = 0;
        this._gfxBox.scale.set(0.5);

        this._textMult = this.addChild(new PIXI.BitmapText("1",this._style))
        this._textSplit = this.addChild(new PIXI.BitmapText("1",this._style))

        this.onResize();
        this.enable(false);
    }

    public get multValue(): number {
        return this.enabled || this.isSummary ? parseFloat(this._textMult.text) : 0;
    }

    public get splitValue(): number {
        return this.enabled || this.isSummary ? parseFloat(this._textSplit.text) : 0;
    }

    public set multValue(val: number) {
        if(val === this.multValue) return;
        this._textMult.text = val.toString();
        AnimationEffects.Bounce(this._textMult);
        Helper.setTimeline().fromTo(this._gfxBox,{alpha:1},{alpha:0,duration:0.25});
        if(this.multValue > 9)
            this.onResize(undefined,false);
    }

    public set splitValue(val: number) {
        if(val === this.splitValue) return;
        this._textSplit.text = val.toString();
        AnimationEffects.Bounce(this._textSplit);
        Helper.setTimeline().fromTo(this._gfxBox,{alpha:1},{alpha:0,duration:0.25});
        if(this.splitValue > 9)
            this.onResize(undefined,false);
    }

    public setupSum(): void {
        this.multValue = this.splitValue = 0;
    }

    public enable(value: boolean, reset:boolean = false): gsap.core.Timeline {
        if(this.enabled === value) return new gsap.core.Timeline();
        this.onResize();

        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline({ onComplete:() =>  { this.soonEnabled = this.isEnabled }}));

        this.enabled = value;

        ResizeHelper.isLandscape ? this.landscapeMode() : this.potraitMode();

        if(reset) this._timeline.add(() => { this.multValue = this.splitValue = 1}, this.enabled ? 0 : undefined);

        return this._timeline;
    }

    private landscapeMode(): void {
        const originalXPos = this.prefPos.x;
        const dirrPos = originalXPos + 150;
        if (this.enabled) {
            this._timeline.fromTo(this,{alpha:0,x:dirrPos},{alpha:1, x:originalXPos,ease:Power3.easeOut,duration:0.8})
        } else {
            this._timeline.fromTo(this,{alpha:1,x:originalXPos},{alpha:0,x:dirrPos,ease:Power3.easeOut,duration:0.65})
        }
    }

    private potraitMode(): void {
        const originalYPos = this.prefPos.y;
        const dirrPos = originalYPos - 150;
        if (this.enabled) {
            this._timeline.fromTo(this,{alpha:0,y:dirrPos},{alpha:1, y:originalYPos,ease:Power3.easeOut,duration:0.8})
        } else {
            this._timeline.fromTo(this,{alpha:1,y:originalYPos},{alpha:0,y:dirrPos,ease:Power3.easeOut,duration:0.65})
        }
    }

    onResize(_prefPos?:PIXI.Point, resetTL:boolean = true): void {
        if(resetTL) this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline(), true);
        this._carBox.texture = this.boxTexture;
        this._gfxBox.texture = this.gfxTexture;


        if(this._timeline && this._timeline.isActive()) this._timeline.progress(1);

        if(_prefPos){
            this.position = _prefPos;
            this.prefPos = _prefPos;
        }else
            this.prefPos = this.prefPos;

        if (ResizeHelper.isLandscape || this.isSummary) {
            this._textMult.position.set(this.multValue >= 10 ? -8 : 4, -45);
            this._textSplit.position.set(this.splitValue >= 10 ? -8 : 4, 10);
        } else {
            this._textMult.position.set(this.multValue >= 10 ? -52 : -38 ,-30)
            this._textSplit.position.set(this.splitValue >= 10 ? 8 : 20 ,-30)
        }
    }
}